module.exports = __webpack_public_path__ + "static/media/item_5_16_comp.b49fcc64.png";